// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"folder-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M2 20L22 20V9.75L2 9.75L2 20Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M9 3.5H2V9.75H22V6H11L9 3.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M2 9.75V20H22V9.75M2 9.75H22M2 9.75V3.5H9L11 6H22V9.75","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-folder-1')
export default class Folder1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-1',
    }
  }
}
